<template>
  <el-dialog
    :title="title || $t('video.title')"
    :visible.sync="visible"
    width="90%"
    class="video-dialog"
    :before-close="handleClose"
    @opened="handleOpened"
    @closed="handleClosed"
  >
    <div class="video-container">
      <video
        ref="videoPlayer"
        :src="videoSrc"
        controls
        controlslist="nodownload"
        :poster="poster"
        class="video-player"
        @play="handlePlay"
        @pause="handlePause"
        @ended="handleEnded"
      >
        {{ $t('video.notSupported') }}
      </video>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'VideoPop',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    videoSrc: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    poster: {
      type: String,
      default: ''
    },
    autoplay: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClose() {
      // 暂停视频播放
      if (this.$refs.videoPlayer) {
        this.$refs.videoPlayer.pause();
      }
      this.$emit('close');
    },
    handleOpened() {
      // 弹窗打开后的处理
      if (this.autoplay && this.$refs.videoPlayer) {
        this.$refs.videoPlayer.play().catch(() => {
          // 自动播放失败（浏览器限制）
        });
      }
      this.$emit('opened');
    },
    handleClosed() {
      // 弹窗关闭后重置视频
      if (this.$refs.videoPlayer) {
        this.$refs.videoPlayer.currentTime = 0;
      }
      this.$emit('closed');
    },
    handlePlay() {
      this.$emit('play');
    },
    handlePause() {
      this.$emit('pause');
    },
    handleEnded() {
      this.$emit('ended');
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  border-radius: 12px;
  max-width: 1200px;
  
  .el-dialog__header {
    padding: 24px 24px 16px;
    border-bottom: 1px solid #E5E5E5;
    
    .el-dialog__title {
      font-size: 20px;
      font-weight: 600;
      color: #0A0A0A;
    }
    
    .el-dialog__headerbtn {
      top: 24px;
      right: 24px;
      font-size: 24px;
      
      .el-dialog__close {
        color: #999;
        &:hover {
          color: rgb(239, 129, 77);
        }
      }
    }
  }
  
  .el-dialog__body {
    padding: 24px;
  }
}

.video-container {
  width: 100%;
  background: #000;
  border-radius: 8px;
  overflow: hidden;
  
  .video-player {
    width: 100%;
    height: auto;
    max-height: 70vh;
    display: block;
    outline: none;
  }
}


@media screen and (max-width: 850px) {
  ::v-deep .el-dialog {
    width: 95% !important;
    margin-top: 5vh !important;
    
    .el-dialog__header {
      padding: 16px 16px 12px;
      
      .el-dialog__title {
        font-size: 18px;
      }
      
      .el-dialog__headerbtn {
        top: 16px;
        right: 16px;
        font-size: 20px;
      }
    }
    
    .el-dialog__body {
      padding: 16px;
    }
  }
  
  .video-container {
    .video-player {
      max-height: 50vh;
    }
  }
  
}
</style>

